import { authService } from '../../service/auth-service'
import { logger } from '../../util/logger'
import { ErrorMessageHint } from '../util/error-message-hint'
import { OverlaySpinner } from '../util/spinner/overlay-spinner'
import { LegalAgreementSentance } from './legal-agreement-sentance'
import { browserUtil } from '@grndhouse/react-common'
import { accessTokenService } from '@grndhouse/react-common/lib/service/token'
import { yupResolver } from '@hookform/resolvers/yup'
import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'

const setUserNameSchema = yup
  .object()
  .shape({
    isUserAgreeing: yup.bool().oneOf([true], 'You need to agree to Terms & Conditions and Privacy Policy'),
  })
  .required()

type FormValues = {
  isUserAgreeing: boolean
}

export const LegalAgreementForm = (): React.ReactElement => {
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({ resolver: yupResolver(setUserNameSchema) })

  const onSubmit = async (): Promise<void> => {
    try {
      if (setIsLoading) setIsLoading(true)
      setErrorMessage(undefined)
      await authService.agreeToLatestLegalAgreements()
      await accessTokenService.refresh()
      browserUtil.redirect('/')
    } catch (err) {
      logger.error(err)
      setErrorMessage(err.message)
    } finally {
      if (setIsLoading) setIsLoading(false)
    }
  }
  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group className="text-center">
          <Form.Control
            id="agree"
            type="checkbox"
            {...register('isUserAgreeing')}
            className={`inline-check-box ${errors.isUserAgreeing ? 'is-invalid' : ''}`}
          />
          <label htmlFor="agree">
            <small>
              <LegalAgreementSentance />
            </small>
          </label>
          <Form.Control.Feedback type="invalid">
            {errors.isUserAgreeing && <p>{errors.isUserAgreeing.message}</p>}
          </Form.Control.Feedback>
        </Form.Group>
        <ErrorMessageHint message={errorMessage} />
        <Form.Group className="form-group">
          <Button type="submit" className="w-100">
            Confirm
          </Button>
        </Form.Group>
      </Form>
      {isLoading && <OverlaySpinner />}
    </>
  )
}
